import { useFetcher } from 'react-router-dom';
import Expire from '@/components/Expire';
import { LeadActionError } from '@/components/LeadActionError';
import { Button } from '@/components/ui/button.tsx';
import { ButtonGroup } from '@/components/ui/button-group.tsx';
import type { ErrorResponse } from '@/models/ui/actions.ts';
import type { StepsModel } from '@/models/ui/steps';

interface LeadActionButtonsProps {
  readonly stepsModel: StepsModel;
  readonly hasOdometer: boolean;
  readonly errorMessageDelay?: number;
}

export function LeadActionButtons({
  stepsModel,
  hasOdometer,
  errorMessageDelay = 3000,
}: LeadActionButtonsProps) {
  const fetcher = useFetcher<ErrorResponse>({ key: 'workflow-fetcher' });

  const currentStep = stepsModel.currentStep;

  return (
    <menu
      aria-label="Actions"
      className="flex flex-col items-center mt-8 relative"
      tabIndex={-1}
    >
      {fetcher.data?.status === 400 &&
        fetcher.data.headers['X-Requested-With'] === 'client-app' && (
          <Expire key={fetcher.data.headers.ETag} delay={errorMessageDelay}>
            <LeadActionError
              key={fetcher.data.headers.ETag}
              message={fetcher.data?.data.error}
            />
          </Expire>
        )}
      <fetcher.Form method="post" className="flex flex-col items-center w-full">
        <input type="hidden" name="hasOdometer" value={String(hasOdometer)} />
        <ButtonGroup orientation="vertical" className="w-full max-w-sm">
          <Button
            name="action"
            form={currentStep.primaryAction.form}
            value={currentStep.primaryAction.key}
            type="submit"
            variant="default"
            disabled={fetcher.state !== 'idle'}
          >
            {currentStep.primaryAction.label}
          </Button>
          {currentStep.secondaryActions.length > 0 && (
            <ButtonGroup className="w-full">
              {currentStep.secondaryActions.map((action) => (
                <Button
                  key={action.key}
                  variant="secondary"
                  size="sm"
                  name="action"
                  value={action.key}
                  type="submit"
                  className="flex-1"
                  disabled={fetcher.state !== 'idle'}
                >
                  {action.label}
                </Button>
              ))}
            </ButtonGroup>
          )}
        </ButtonGroup>
      </fetcher.Form>
    </menu>
  );
}
